// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__Vnum4","title":"Images90_title__3ZKWW","images":"Images90_images__tOYmH"};